import React from 'react';

import InfoCard from './infoCard.js';
import { Typography } from '@material-ui/core';

export default function AskMeAnythingCard(props) {
    const { amaCards } = props;
    const ama = amaCards[0];
    if (!ama) return <div />
    const { idIncubator, date, time, ...user } = ama;
    const to = idIncubator
        ? `/incubator?idIncubator=${idIncubator}&initialTab=discussion`
        : '/workshopList';
    return (
        <InfoCard
            className='ama'
            to={to}
            titleStyle={{ backgroundColor: '#4457CF', color: '#FFFFFF' }}
            userStyle={{ backgroundColor: '#4391C8', color: '#FFFFFF' }}
            contentStyle={{ backgroundColor: '#4457CF', color: '#FFFFFF' }}
            title='Live Forum'
            user={user}
            content={
                <>
                    <Typography variant='body2'>{date}</Typography>
                    <Typography variant='body2'>{time}</Typography>
                </>
            }
        />
    );
}